<template>
	<PopupRouterView :showLeftIcon="true" label="Posting Supply For Production Input" okTitle="Save"
		cancelTitle="Cancel" entityName="postingsupplyforproduction" :documentId="mainRecordId" @saveMethod="saveAction"
		@hideMethod="onHidden" ref="postingSupplyForProductionInput" modalClass="input-scan-page">

		<template #modal-header-left-button>
			<span class="mr-1 d-sm-flex d-md-none">
				<b-button size="sm" class="ml-1 btn-back " @click="$router.back()"><b-icon-arrow-left /></b-button>
			</span>
		</template>

		<div class="p-2">
			<span v-if="scanPageIndex == 1">
				<b-row>
					<b-col cols="12">
						<app-input-textbox label="Line" id="input-posting-supply-detail-for-production-line" size="sm"
							:isEditable="false" :model="model.line != null ? model.line.name : ''" />
					</b-col>
					<b-col cols="12">
						<app-input-scan id="input-control-card" ref="input-control-card" :model.sync="filterMaterial"
							label="Control Card" @scannedMethod="scanControlCard" autofocus />
					</b-col>
					<!-- end page 1 -->
					<!-- page 2 -->
					<b-col cols="12">
						<app-list :isDataLoading="isPostingSupplyDetailForProductionComboLoading"
							:dataCount="postingSupplyDetailForProductions.length">
							<b-list-group-item>
								<div class="list-title" v-for="(item, index) in postingSupplyDetailForProductions"
									@click="goToNext(2, item)">
									<b-row>
										<b-col cols="8">
											<span class="font-small">{{ item.materialPart != null
												? item.materialPart.partNumber
												: '' }}</span> <br />
											<span class="detailItem">{{ item.materialPart != null
												? item.materialPart.partName :
												'' }}</span> <br />
											<span class="detailItem">{{ item.qtySupply }}</span>
										</b-col>
										<b-col cols="4">
											<span :class="getStatusClass(item.documentStatusId)">{{
												getStatusName(item.documentStatusId) }}</span>
										</b-col>
									</b-row>
									<hr />
								</div>
							</b-list-group-item>
						</app-list>
					</b-col>
				</b-row>
			</span>
			<span v-if="scanPageIndex == 2">
				<b-row>
					<!-- end page 2 -->
					<!-- page 3 -->
					<b-col cols="12">
						<app-input-textbox label="Line" id="input-posting-supply-detail-for-production-line" size="sm"
							:isEditable="false" :model="model.line != null ? model.line.name : ''" />
					</b-col>
					<b-col cols="6">
						<app-input-textbox label="Part Number"
							id="input-posting-supply-detail-for-production-part-number" size="sm" :isEditable="false"
							:model="postingDetail != null && postingDetail.materialPart != null ? postingDetail.materialPart.partNumber : ''" />
						<app-input-textbox label="Part Name" id="input-posting-supply-detail-for-production-part-name"
							size="sm" :isEditable="false"
							:model="postingDetail != null && postingDetail.materialPart != null ? postingDetail.materialPart.partName : ''" />
					</b-col>
					<b-col cols="6">
						<app-input-textbox label="Plan Supply"
							id="input-posting-supply-detail-for-production-plan-supply" size="sm" :isEditable="false"
							:model="postingDetail.qtySupply" />
						<app-input-textbox label="Actual Supply"
							id="input-posting-supply-detail-for-production-actual-supply" size="sm" :isEditable="false"
							:model="actualSupply" />
					</b-col>
					<b-col cols="12" class="mt-2">
						<app-label label-cols-lg="12" size="sm" label="List Case" model="List Case" :nolabel="true" />

						<b-table id="table-list-postingsupplycases" :class="'table-action'" head-variant="head-light"
							:bordered="true" :items="postingSupplyCases" :fields="fields" small responsive show-empty>
							<template #empty>
								<app-no-data-image />
							</template>

						</b-table>
					</b-col>
				</b-row>
			</span>
			<span v-if="scanPageIndex == 3">
				<b-row>
					<b-col cols="12">
						<app-input-scan id="fieldset-pic-picking" ref="fieldset-pic-picking"
							:model.sync="picPickingQrCode" label="Pic Picking Material Issue"
							@scannedMethod="scanPic('picking')" :isBusy="isScanPicLoading"
							:waitInputScan="waitInputScanPicPicking" @clearMethod="clearMethodScanPicPicking"
							autofocus />
						<app-input-scan id="fieldset-pic-penerima" ref="fieldset-pic-penerima"
							:model.sync="picPenerimaQrCode" label="Pic Penerima" @scannedMethod="scanPic('penerima')"
							:waitInputScan="waitInputScanPicPenerima" @clearMethod="clearMethodScanPicPenerima"
							:isBusy="isScanPicLoading" />
					</b-col>
				</b-row>
			</span>

			<span v-if="scanPageIndex == 4">
				<b-row>
					<b-col cols="12">
						<app-input-scan id="fieldset-rack" ref="fieldset-rack" :model.sync="rackQrCode" label="Rack"
							@scannedMethod="scanRack" :isBusy="isScanRackLoading" autofocus />
					</b-col>
				</b-row>
			</span>

		</div>


		<b-overlay :show="isBusy" no-wrap></b-overlay>
		<template #modal-action-button>
			<b-button v-if="scanPageIndex == 2" size="sm" class="btn-fill-danger float-right"
				@click="goToNext(1)">Back</b-button>
			<b-button v-if="scanPageIndex == 2 && postingDetail.documentStatusId != 'CLOSED'" size="sm"
				class="btn-fill-success float-right" @click="goToNext(3)">Next</b-button>
			<b-button v-if="scanPageIndex == 3" size="sm" class="btn-fill-danger float-right"
				@click="goToNext(2, postingDetail)">Back</b-button>
			<b-button v-if="scanPageIndex == 3" size="sm" class="btn-fill-success float-right"
				@click="goToNext(4)">Next</b-button>
			<b-button v-if="scanPageIndex == 4" size="sm" class="btn-fill-danger float-right"
				@click="goToNext(3)">Back</b-button>
			<!-- <b-button v-if="scanPageIndex == 4" size="sm" class="btn-fill-success float-right"
				@click="finishAction()">Finish</b-button> -->

		</template>
		<PostingSupplyDetailForProductionScan :parentLabelInfo="parentLabelInfo" :parentValueInfo="parentValueInfo"
			:model="modelPostingSupplyDetailForProduction" :modelId="postingSupplyDetailForProductionId"
			:openPopup="isShowPopupPostingSupplyDetailForProduction" @resetMethod="resetModal"
			@addButtonMethod="addRowDataPostingSupplyDetailForProduction" />
		<PostingSupplyCaseScan :parentLabelInfo="parentLabelInfo" :parentValueInfo="parentValueInfo"
			:model="modelPostingSupplyCase" :modelId="postingSupplyCaseId" :openPopup="isShowPopupPostingSupplyCase"
			@resetMethod="resetModal" @addButtonMethod="addRowDataPostingSupplyCase" />

	</PopupRouterView>
</template>

<style>
.detailItem {
	color: black !important;
}

.detailItem,
.font-small {
	font-size: 15px;
}
</style>

<script>
import axios from 'axios';
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import toast from '@/mixins/toastMixin';
import focusInput from '@/mixins/focusInputMixin';
import AppInputScan from '@/components/AppInputScan';
import AppList from '@/components/AppList';
import PostingSupplyForProduction from '@/models/PostingSupplyForProduction/PostingSupplyForProduction';
import PostingSupplyForProductionList from '@/models/PostingSupplyForProduction/PostingSupplyForProductionList';
import PostingSupplyForProductionFilter from '@/filters/PostingSupplyForProduction/PostingSupplyForProductionFilter';
import AppInputComboboxAutocomplete from '@/components/AppInputComboboxAutocomplete';
import PickingSupplyForProduction from '@/models/PickingSupplyForProduction/PickingSupplyForProduction';
import PickingSupplyForProductionFilter from '@/filters/PickingSupplyForProduction/PickingSupplyForProductionFilter';
import WorkOrderSupply from '@/models/WorkOrderSupply/WorkOrderSupply';
import WorkOrderSupplyFilter from '@/filters/WorkOrderSupply/WorkOrderSupplyFilter';
import WorkOrderProcess from '@/models/WorkOrderProcess/WorkOrderProcess';
import WorkOrderProcessFilter from '@/filters/WorkOrderProcess/WorkOrderProcessFilter';
import Line from '@/models/Line/Line';
import LineFilter from '@/filters/Line/LineFilter';
import AppInputDatepicker from '@/components/AppInputDatepicker';
import AppInputDatepickerRange from '@/components/AppInputDatepickerRange';
import DocumentStatus from '@/models/DocumentStatus/DocumentStatus';
import DocumentStatusFilter from '@/filters/DocumentStatus/DocumentStatusFilter';
import PostingSupplyDetailForProduction from '@/models/PostingSupplyForProduction/PostingSupplyDetailForProduction';
import PostingSupplyDetailForProductionFilter from '@/filters/PostingSupplyForProduction/PostingSupplyDetailForProductionFilter';
import PostingSupplyCase from '@/models/PostingSupplyForProduction/PostingSupplyCase';
import PostingSupplyCaseFilter from '@/filters/PostingSupplyForProduction/PostingSupplyCaseFilter';
import PickingSupplyForProductionDetail from '@/models/PickingSupplyForProduction/PickingSupplyForProductionDetail';
import PickingSupplyForProductionDetailFilter from '@/filters/PickingSupplyForProduction/PickingSupplyForProductionDetailFilter';
import Part from '@/models/Part/Part';
import PartFilter from '@/filters/Part/PartFilter';
import AppInputTextbox from '@/components/AppInputTextbox';
import UserInfo from '@/models/UserInfo/UserInfo';
import UserInfoFilter from '@/filters/UserInfo/UserInfoFilter';
import AppInputTimepicker from '@/components/AppInputTimepicker';
import AppInputTimepickerRange from '@/components/AppInputTimepickerRange';
import Area from '@/models/Area/Area';
import AreaFilter from '@/filters/Area/AreaFilter';
import Rack from '@/models/Rack/Rack';
import RackFilter from '@/filters/Rack/RackFilter';
import AppTableInput from '@/components/AppTableInput';
import AppTableInputPopup from '@/components/AppTableInputPopup';
import PostingSupplyDetailForProductionInput from '@/views/PostingSupplyForProduction/PostingSupplyDetailForProductionInput';
import PostingSupplyDetailForProductionScan from '@/views/PostingSupplyForProduction/PostingSupplyDetailForProductionScan';
import PostingSupplyDetailForProductionUpload from '@/views/PostingSupplyForProduction/PostingSupplyDetailForProductionUpload';
import ControlCard from '@/models/ControlCard/ControlCard';
import ControlCardFilter from '@/filters/ControlCard/ControlCardFilter';
import PostingSupplyCaseInput from '@/views/PostingSupplyForProduction/PostingSupplyCaseInput';
import PostingSupplyCaseScan from '@/views/PostingSupplyForProduction/PostingSupplyCaseScan';
import PostingSupplyCaseUpload from '@/views/PostingSupplyForProduction/PostingSupplyCaseUpload';
import PopupRouterView from '@/components/PopupRouterView';
import AppLabel from '@/components/AppLabel';

export default {
	components: {
		AppInputComboboxAutocomplete,
		AppInputDatepicker,
		AppInputDatepickerRange,
		AppInputTextbox,
		AppInputTimepicker,
		AppInputTimepickerRange,
		PostingSupplyDetailForProductionInput,
		PostingSupplyDetailForProductionScan,
		PostingSupplyDetailForProductionUpload,
		PostingSupplyCaseInput,
		PostingSupplyCaseScan,
		PostingSupplyCaseUpload,
		AppTableInput,
		AppTableInputPopup,
		PopupRouterView,
		AppInputScan,
		AppList,
		AppLabel,
	},
	mixins: [validationMixin, toast, focusInput],
	validations: {
		model: {
		},
	},
	data() {
		return {
			errorMessage: {
			},
			datas: Array(),
			selectAll: false,
			sortBy: '',
			sortDesc: '',
			pagingOptions: [
				{ value: '10', text: '10', selected: true },
				{ value: '25', text: '25' },
				{ value: '50', text: '50' },
				{ value: '100', text: '100' },
			],
			fieldsPostingSupplyDetailForProduction: [
				{ "frontActions": { "class": "th-actions", "label": "" } },
				{ "no": { "class": "th-number d-stack-none" } },
				{ "pickingSupplyForProductionDetail": { "class": "th-picking-supply-for-production-detail first-child", "label": "Picking Supply For Production Detail", key: 'pickingSupplyForProductionDetail.materialPart', sortable: false } },
				{ "part": { "class": "th-part", "label": "Part", key: 'part.partNumber', sortable: false } },
				{ "materialPart": { "class": "th-material-part last-child", "label": "Material Part", key: 'materialPart.partNumber', sortable: false } },
				{ "qtySupply": { "class": "th-qty-supply d-stack-none", "label": "Qty Supply", key: 'qtySupply', sortable: false } },
				{ "picPicking": { "class": "th-pic-picking d-stack-none", "label": "Pic Picking", key: 'picPicking.firstName', sortable: false } },
				{ "picPenerima": { "class": "th-pic-penerima d-stack-none", "label": "PicPenerima", key: 'picPenerima.firstName', sortable: false } },
				{ "line": { "class": "th-line d-stack-none", "label": "Line", key: 'line.code', sortable: false } },
				{ "postingDate": { "class": "th-posting-date d-stack-none", "label": "PostingDate", key: 'postingDate', sortable: false } },
				{ "area": { "class": "th-area d-stack-none", "label": "Area", key: 'area.code', sortable: false } },
				{ "rack": { "class": "th-rack d-stack-none", "label": "Rack", key: 'rack.code', sortable: false } },
				{ "documentStatus": { "class": "th-document-status d-stack-none", "label": "Document Status", key: 'documentStatus.name', sortable: false } },
				{ "actions": { "class": "th-actions d-stack-show", "label": "" } }
			],
			fieldsPostingSupplyCase: [
				{ "frontActions": { "class": "th-actions", "label": "" } },
				{ "no": { "class": "th-number d-stack-none" } },
				{ "postingSupplyDetailForProduction": { "class": "th-posting-supply-detail-for-production first-child", "label": "Posting Supply Detail For Production", key: 'postingSupplyDetailForProduction.pickingSupplyForProductionDetail', sortable: false } },
				{ "pickingSupplyDetailForProduction": { "class": "th-picking-supply-detail-for-production", "label": "Picking Supply Detail For Production", key: 'pickingSupplyDetailForProduction.materialPart', sortable: false } },
				{ "controlCard": { "class": "th-control-card last-child", "label": "Control Card", key: 'controlCard.controlCardNumber', sortable: false } },
				{ "part": { "class": "th-part d-stack-none", "label": "Part", key: 'part.partNumber', sortable: false } },
				{ "qty": { "class": "th-qty d-stack-none", "label": "Qty", key: 'qty', sortable: false } },
				{ "area": { "class": "th-area d-stack-none", "label": "Area", key: 'area.code', sortable: false } },
				{ "rack": { "class": "th-rack d-stack-none", "label": "Rack", key: 'rack.code', sortable: false } },
				{ "documentStatus": { "class": "th-document-status d-stack-none", "label": "Document Status", key: 'documentStatus.name', sortable: false } },
				{ "actions": { "class": "th-actions d-stack-show", "label": "" } }
			],
			fields: [
				{ "controlCard": { "class": "th-control-card last-child", "label": "Case Number", key: 'controlCard.controlCardNumber', sortable: false } },
				{ "qtyCase": { "class": "th-qty d-stack-none", "label": "Qty", key: 'controlCard.qtyCase', sortable: false } },
			],
			busy: false,
			isBusy: false,
			isDataLoading: false,
			selected: '',
			pageSizeOptions: 10,
			pageIndex: 0,
			sortingBy: Array(),
			modelId: null,
			model: {},
			modelPostingSupplyDetailForProduction: {},
			isShowPopupPostingSupplyDetailForProduction: false,
			isShowPopupUploadPostingSupplyDetailForProduction: false,
			isShowPopupPostingSupplyDetailForProductionScan: false,
			modelPostingSupplyCase: {},
			isShowPopupPostingSupplyCase: false,
			isShowPopupUploadPostingSupplyCase: false,
			isShowPopupPostingSupplyCaseScan: false,
			filterPostingSupplyForProduction: null,
			currentPostingSupplyForProductionPage: 1,
			postingSupplyForProductionPageSize: 10,
			sortByPostingSupplyForProduction: '',
			sortDescPostingSupplyForProduction: '',
			filterPostingSupplyDetailForProduction: null,
			currentPostingSupplyDetailForProductionPage: 1,
			postingSupplyDetailForProductionPageSize: 10,
			sortByPostingSupplyDetailForProduction: '',
			sortDescPostingSupplyDetailForProduction: '',
			sortingByPostingSupplyDetailForProduction: [],
			postingSupplyDetailForProductions: [],
			postingSupplyDetailForProductionId: '',
			totalPostingSupplyDetailForProductionRow: 0,
			isShowPostingSupplyDetailForProductionFilter: false,
			isDownloadPostingSupplyDetailForProduction: false,
			filterPostingSupplyCase: null,
			currentPostingSupplyCasePage: 1,
			postingSupplyCasePageSize: 10,
			sortByPostingSupplyCase: '',
			sortDescPostingSupplyCase: '',
			sortingByPostingSupplyCase: [],
			postingSupplyCases: [],
			postingSupplyCaseId: '',
			totalPostingSupplyCaseRow: 0,
			isShowPostingSupplyCaseFilter: false,
			isDownloadPostingSupplyCase: false,
			pickingSupplyForProductionDetails: [],
			parts: [],
			userInfos: [],
			lines: [],
			areas: [],
			racks: [],
			documentStatuss: [],
			postingSupplyDetailForProductions: [],
			controlCards: [],
			pickingSupplyForProductions: [],
			pickingSupplyForProductions: [],
			isPickingSupplyForProductionComboLoading: false,
			workOrderSupplys: [],
			workOrderSupplys: [],
			isWorkOrderSupplyComboLoading: false,
			workOrderProcesss: [],
			workOrderProcesss: [],
			isWorkOrderProcessComboLoading: false,
			isShowPopupConfirmation: false,
			isDataCommited: false,
			mainRecordId: '',
			isPickingSupplyForProductionComboLoading: false,
			isWorkOrderSupplyComboLoading: false,
			isWorkOrderProcessComboLoading: false,
			isLineComboLoading: false,
			isDocumentStatusComboLoading: false,
			isPostingSupplyForProductionComboLoading: false,
			isPickingSupplyForProductionDetailComboLoading: false,
			isPartComboLoading: false,
			isUserInfoComboLoading: false,
			isAreaComboLoading: false,
			isRackComboLoading: false,
			isPostingSupplyDetailForProductionComboLoading: false,
			isControlCardComboLoading: false,
			scanPageIndex: 1,
			parentLabelInfo: '',
			parentValueInfo: '',
			postingDetail: '',
			filterMaterial: '',
			picPickingQrCode: '',
			picPenerimaQrCode: '',
			rackQrCode: '',
			isScanRackLoading: false,
			isScanPicLoading: false,
			actualSupply: 0,
			waitInputScanPicPenerima: false,
			waitInputScanPicPicking: false,
		}
	},
	methods: {
		async scanControlCard() {
			let data = await this.getPostingSupplyDetailForProductions();
			if (data == null || data == undefined || data.length <= 0) {
				this.filterMaterial = '';
				this.dangerToast("Control card tidak ditemukan");
				return;
			} else {
				data = data[0];
				this.goToNext(2, data);
			}
			this.filterMaterial = '';
		},
		finishAction() {
			this.isBusy = true;
			if (this.rackQrCode == "") {
				this.toast({ message: 'Silahkan scan rack terlebih dahulu', title: 'Error', variant: 'danger' });
				this.isBusy = false;
				return;
			}
			PostingSupplyForProduction.finishScan(this, this.postingDetail.id)
				.then(result => {
					this.toast({ message: 'Control card berhasil diposting', title: 'Success', variant: 'success', autoHideDelay: 2000 });
					this.goToNext(1);
					this.isBusy = false;
				}).catch(error => { this.isBusy = false; });
		},
		getStatusName(status) {
			switch (status) {
				case 'OPEN':
					return 'Belum Posting';
				case 'IN_PROGRESS':
					return 'Progress Posting';
				case 'CLOSED':
					return 'Finish Posting';
				default:
					return '';
			}
		},
		getStatusClass(status) {
			switch (status) {
				case 'OPEN':
					return 'text-danger font-small';
				case 'IN_PROGRESS':
					return 'text-warning font-small';
				case 'CLOSED':
					return 'text-success font-small';
				default:
					return '';
			}
		},
		scanRack() {
			this.isBusy = true;
			PostingSupplyForProduction.scanRack(this, this.postingDetail.id, this.rackQrCode)
				.then(result => {
					this.finishAction();
					//this.successToast();
					this.isBusy = false;
				}).catch(error => {
					this.rackQrCode = '';
					this.isBusy = false;
				});
		},
		clearMethodScanPicPenerima() {
			this.picPenerimaQrCode = '';
			this.waitInputScanPicPenerima = false;

			this.$nextTick(() => {
				this.focusInput(this, "fieldset-pic-penerima");
			});
		},
		clearMethodScanPicPicking() {
			this.picPickingQrCode = '';
			this.waitInputScanPicPicking = false;

			this.$nextTick(() => {
				this.focusInput(this, "fieldset-pic-picking");
			});
		},
		async scanPic(prefix) {
			this.isBusy = true;
			try {
				await PostingSupplyForProduction.scanPic(this, this.postingDetail.id, this.picPickingQrCode, this.picPenerimaQrCode);
				if (this.picPickingQrCode || this.picPenerimaQrCode) {
					this.successToast();
				}
				this.isBusy = false;
				if (prefix == 'picking') {
					this.focusInput(this, "fieldset-pic-penerima");
				}
			} catch {
				this.getPostingSupplyDetailForProduction(this.postingDetail.id).then(res => {
					if (res.picPickingUserName == null) {
						this.picPickingQrCode = '';
						this.focusInput(this, "fieldset-pic-picking");
					} else {
						this.focusInput(this, "fieldset-pic-penerima");
					}
					if (res.picPenerimaUserName == null) {
						this.picPenerimaQrCode = '';
					}

				}).catch(err => {
					this.picPenerimaQrCode = '';
					this.picPickingQrCode = '';
				});
				this.isBusy = false;
				return false;
			}
			return true;
		},
		dangerToast(message) {
			this.toast({ message: message, title: 'Error', variant: 'danger' });
		},
		successToast() {
			this.toast({ message: 'Scan berhasil', title: 'Sukses', variant: 'success' });
		},
		getPostingSupplyForProduction: async function (id) {
			this.isBusy = true;
			PostingSupplyForProduction.getData(this, id).then(result => {
				this.model = result;
				this.mainRecordId = String(result.mainRecordId);
				let promises = Array();

				Promise.all(promises).then((results) => {
					this.isBusy = false;
				});
			}).catch(error => { this.isBusy = false; });
		},
		getPostingSupplyDetailForProduction: async function (id) {
			this.isBusy = true;
			try {
				let data = await PostingSupplyDetailForProduction.getData(this, id);
				return data;
				// .then(result => {
				// 	this.model = result;
				// 	this.mainRecordId = String(result.mainRecordId);
				// 	let promises = Array();

				// 	Promise.all(promises).then((results) => {
				// 		this.isBusy = false;
				// 	});
				// }).catch(error => { this.isBusy = false; });
			} catch { }
		},
		downloadData() {
			this.isDownloadPostingSupplyForProduction = true;
			this.filterPostingSupplyForProduction.id = this.modelId;
			PostingSupplyForProduction.downloadDataDetail(this, this.filterPostingSupplyForProduction).then(result => {
				this.isDownloadPostingSupplyForProduction = false;
			}).catch(error => { this.isDownloadPostingSupplyForProduction = false; })
		},
		AddRowPostingSupplyDetailForProductions: async function (isAddRow) {
			let filter = {};
			Object.assign(filter, this.filterPostingSupplyDetailForProduction);
			if (this.modelId == null) return;
			filter.postingSupplyForProductionId = this.modelId;
			filter.draftMode = "1";
			if (this.sortByPostingSupplyDetailForProduction != null) {
				this.sortingByPostingSupplyDetailForProduction[this.sortByPostingSupplyDetailForProduction] = this.sortDescPostingSupplyDetailForProduction;
			}
			let currentPage = (this.currentPostingSupplyDetailForProductionPage - 1);
			if (isAddRow) {
				let totalData = this.totalPostingSupplyDetailForProductionRow + 1;
				let page = Math.ceil(totalData / this.postingSupplyDetailForProductionPageSize);
				currentPage = page - 1;
			}
			// disable paging start
			currentPage = null;
			this.postingSupplyDetailForProductionPageSize = 0;
			// disable paging end
			PostingSupplyDetailForProduction.getList(this, filter, this.sortingByPostingSupplyDetailForProduction, currentPage, this.postingSupplyDetailForProductionPageSize).then(result => {
				this.currentPostingSupplyDetailForProductionPage = currentPage + 1;
				this.postingSupplyDetailForProductions = result.data.filter(obj =>
					Object.prototype.hasOwnProperty.call(obj, 'isScanned') && (obj.isScanned == false || obj.isScanned == null || obj.isScanned == undefined)
				);
				this.postingSupplyDetailForProductionsFiltered = result.data.filter(obj =>
					Object.prototype.hasOwnProperty.call(obj, 'isScanned') && (obj.isScanned == true)
				);
				this.totalPostingSupplyDetailForProductionRow = result.dataCount;
			}).catch(error => { });
		},
		getPostingSupplyCases: async function (isAddRow) {
			let filter = {};
			Object.assign(filter, this.filterPostingSupplyCase);
			if (this.modelId == null) return;
			filter.postingSupplyForProductionId = this.modelId;
			//filter.draftMode = "1";
			filter.postingSupplyDetailForProductionId = this.postingDetail.id;
			this.sortingByPostingSupplyCase["documentstatus"] = 1;
			let currentPage = (this.currentPostingSupplyCasePage - 1);
			if (isAddRow) {
				let totalData = this.totalPostingSupplyCaseRow + 1;
				let page = Math.ceil(totalData / this.postingSupplyCasePageSize);
				currentPage = page - 1;
			}
			// disable paging start
			currentPage = null;
			this.postingSupplyCasePageSize = 0;
			// disable paging end
			this.actualSupply = 0;
			PostingSupplyCase.getList(this, filter, this.sortingByPostingSupplyCase, currentPage, this.postingSupplyCasePageSize).then(result => {
				this.currentPostingSupplyCasePage = currentPage + 1;
				this.postingSupplyCases = result.data.filter(obj =>
					Object.prototype.hasOwnProperty.call(obj, 'isScanned') && (obj.isScanned == false || obj.isScanned == null || obj.isScanned == undefined)
				);
				this.postingSupplyCases.forEach((obj) => {
					let qtyCase = 0;
					if (obj.controlCard != null) {
						qtyCase = obj.controlCard.qtyCase;
					}
					this.actualSupply += qtyCase;
				})
				this.postingSupplyCasesFiltered = result.data.filter(obj =>
					Object.prototype.hasOwnProperty.call(obj, 'isScanned') && (obj.isScanned == true)
				);
				this.totalPostingSupplyCaseRow = result.dataCount;
			}).catch(error => { });
		},
		getPostingSupplyForProductions: async function (input) {
			let filter = new PostingSupplyForProductionFilter();
			if (input != undefined) {
				filter.PickingSupplyForProduction = input;
			}
			this.isPostingSupplyForProductionComboLoading = true;
			await PostingSupplyForProduction.getList(this, filter, null, 0, 10)
				.then(result => {
					if (result != null) {
						this.postingSupplyForProductions = result.data
					}
					this.isPostingSupplyForProductionComboLoading = false;
				})
				.catch(error => { });
		},
		getPostingSupplyForProductions: async function (input) {
			let filter = new PostingSupplyForProductionFilter();
			if (input != undefined) {
				filter.pickingSupplyForProduction = input;
			}
			this.isPostingSupplyForProductionComboLoading = true;
			await PostingSupplyForProduction.getList(this, filter, null, 0, 10)
				.then(result => {
					if (result != null) {
						this.postingSupplyForProductions = result.data
					}
					this.isPostingSupplyForProductionComboLoading = false;
				})
				.catch(error => { });
		},
		getPickingSupplyForProductionDetails: async function (input) {
			let filter = new PickingSupplyForProductionDetailFilter();
			if (input != undefined) {
				filter.materialPart = input;
			}
			this.isPickingSupplyForProductionDetailComboLoading = true;
			await PickingSupplyForProductionDetail.getList(this, filter, null, 0, 10)
				.then(result => {
					if (result != null) {
						this.pickingSupplyForProductionDetails = result.data
					}
					this.isPickingSupplyForProductionDetailComboLoading = false;
				})
				.catch(error => { });
		},
		getParts: async function (input) {
			let filter = new PartFilter();
			if (input != undefined) {
				filter.partNumber = input;
			}
			this.isPartComboLoading = true;
			await Part.getList(this, filter, null, 0, 10)
				.then(result => {
					if (result != null) {
						this.parts = result.data
					}
					this.isPartComboLoading = false;
				})
				.catch(error => { });
		},
		getUserInfos: async function (input) {
			let filter = new UserInfoFilter();
			if (input != undefined) {
				filter.firstName = input;
			}
			this.isUserInfoComboLoading = true;
			await UserInfo.getList(this, filter, null, 0, 10)
				.then(result => {
					if (result != null) {
						this.userInfos = result.data
					}
					this.isUserInfoComboLoading = false;
				})
				.catch(error => { });
		},
		getLines: async function (input) {
			let filter = new LineFilter();
			if (input != undefined) {
				filter.code = input;
			}
			this.isLineComboLoading = true;
			await Line.getList(this, filter, null, 0, 10)
				.then(result => {
					if (result != null) {
						this.lines = result.data
					}
					this.isLineComboLoading = false;
				})
				.catch(error => { });
		},
		getAreas: async function (input) {
			let filter = new AreaFilter();
			if (input != undefined) {
				filter.code = input;
			}
			this.isAreaComboLoading = true;
			await Area.getList(this, filter, null, 0, 10)
				.then(result => {
					if (result != null) {
						this.areas = result.data
					}
					this.isAreaComboLoading = false;
				})
				.catch(error => { });
		},
		getRacks: async function (input) {
			let filter = new RackFilter();
			if (input != undefined) {
				filter.code = input;
			}
			this.isRackComboLoading = true;
			await Rack.getList(this, filter, null, 0, 10)
				.then(result => {
					if (result != null) {
						this.racks = result.data
					}
					this.isRackComboLoading = false;
				})
				.catch(error => { });
		},
		getDocumentStatuss: async function (input) {
			let filter = new DocumentStatusFilter();
			if (input != undefined) {
				filter.name = input;
			}
			this.isDocumentStatusComboLoading = true;
			await DocumentStatus.getList(this, filter, null, 0, 10)
				.then(result => {
					if (result != null) {
						this.documentStatuss = result.data
					}
					this.isDocumentStatusComboLoading = false;
				})
				.catch(error => { });
		},
		getPostingSupplyDetailForProductions: async function (input) {
			let filter = new PostingSupplyDetailForProductionFilter();
			filter.exactType.controlCardNumber = 0;
			if (input != undefined || input != null) {
				filter.controlCardNumber = input;
			} else if (input == null && this.filterMaterial != undefined || this.filterMaterial != null) {
				filter.controlCardNumber = this.filterMaterial;
				filter.exactType.controlCardNumber = 1;
			}
			filter.postingSupplyForProductionId = this.modelId;
			this.isPostingSupplyDetailForProductionComboLoading = true;
			let sortBy = Array();
			sortBy["documentstatus"] = 1;
			try {
				let datas = await PostingSupplyDetailForProduction.getListView(this, filter, sortBy, 0, 1000);
				if (datas != null) {
					this.postingSupplyDetailForProductions = datas.data;
				}
				this.isPostingSupplyDetailForProductionComboLoading = false;
			}
			catch {
				this.isPostingSupplyDetailForProductionComboLoading = false;
			};
			return this.postingSupplyDetailForProductions;
		},
		getControlCards: async function (input) {
			let filter = new ControlCardFilter();
			if (input != undefined) {
				filter.controlCardNumber = input;
			}
			this.isControlCardComboLoading = true;
			await ControlCard.getList(this, filter, null, 0, 10)
				.then(result => {
					if (result != null) {
						this.controlCards = result.data
					}
					this.isControlCardComboLoading = false;
				})
				.catch(error => { });
		},
		getPickingSupplyForProductions: async function (input) {
			let filter = new PickingSupplyForProductionFilter();
			if (input != undefined) {
				filter.workOrderSupply = input;
			}
			await PickingSupplyForProduction.getList(this, filter, null, 0, 10)
				.then(result => {
					if (result != null) {
						this.pickingSupplyForProductions = result.data
					}
				})
				.catch(error => { });
		},
		setSelectedPickingSupplyForProduction(item) {
			if (item == undefined || item == null) {
				this.model.pickingSupplyForProductionId = null;
				this.model.pickingSupplyForProduction = null;
			} else {
				this.model.pickingSupplyForProductionId = item.id;
				this.model.pickingSupplyForProduction = item;
			}
			this.$forceUpdate();
			this.updateData();
		},
		getWorkOrderSupplys: async function (input) {
			let filter = new WorkOrderSupplyFilter();
			if (input != undefined) {
				filter.workOrderSupplyDate = input;
			}
			await WorkOrderSupply.getList(this, filter, null, 0, 10)
				.then(result => {
					if (result != null) {
						this.workOrderSupplys = result.data
					}
				})
				.catch(error => { });
		},
		setSelectedWorkOrderSupply(item) {
			if (item == undefined || item == null) {
				this.model.workOrderSupplyId = null;
				this.model.workOrderSupply = null;
			} else {
				this.model.workOrderSupplyId = item.id;
				this.model.workOrderSupply = item;
			}
			this.$forceUpdate();
			this.updateData();
		},
		getWorkOrderProcesss: async function (input) {
			let filter = new WorkOrderProcessFilter();
			if (input != undefined) {
				filter.workOrderProcessNumber = input;
			}
			await WorkOrderProcess.getList(this, filter, null, 0, 10)
				.then(result => {
					if (result != null) {
						this.workOrderProcesss = result.data
					}
				})
				.catch(error => { });
		},
		setSelectedWorkOrderProcess(item) {
			if (item == undefined || item == null) {
				this.model.workOrderProcessId = null;
				this.model.workOrderProcess = null;
			} else {
				this.model.workOrderProcessId = item.id;
				this.model.workOrderProcess = item;
			}
			this.$forceUpdate();
			this.updateData();
		},
		setSelectedLine(item) {
			if (item == undefined || item == null) {
				this.model.lineId = null;
				this.model.line = null;
			} else {
				this.model.lineId = item.id;
				this.model.line = item;
			}
			this.$forceUpdate();
			this.updateData();
		},
		setSelectedDocumentStatus(item) {
			if (item == undefined || item == null) {
				this.model.documentStatusId = null;
				this.model.documentStatus = null;
			} else {
				this.model.documentStatusId = item.id;
				this.model.documentStatus = item;
			}
			this.$forceUpdate();
			this.updateData();
		},
		validateState(name) {
			if (!this.$v.model[name]) return null;
			const { $dirty, $error } = this.$v.model[name];
			return $dirty ? !$error : null;
		},
		getErrorMessage(message, name) {
			if (!this.$v.model[name]) return "";
			if (this.$v.model[name].required != undefined && !this.$v.model[name].required) {
				if (message.required) return message.required;
			}
		},
		handleScroll() {
			this.$refs.postingSupplyForProductionInput.scrollTop = 0;
		},
		saveAction(modalEvent) {
			if (modalEvent != undefined && modalEvent != null) {
				modalEvent.preventDefault();
			}
			let id = this.$route.params.id;
			this.$v.model.$touch();
			if (this.$v.model.$anyError) {
				return;
			} else {
				this.isBusy = true;
				let id = this.modelId;
				let model = this.model;

				if (id != '' && id != null && id != undefined) {
					PostingSupplyForProduction.commitData(this, model, id).then(result => {
						this.isDataCommited = true;
						this.$router.push({ name: 'postingsupplyforproductionindex' });
						this.isBusy = false;
					}).catch(error => { this.isBusy = false; });
				} else {
					PostingSupplyForProduction.insertData(this, model).then(result => {
						this.isDataCommited = true;
						this.$router.push({ name: 'postingsupplyforproductionindex' });
						this.isBusy = false;
					}).catch(error => { this.isBusy = false; });
				}
			}
		},
		updateData() {
			let id = this.modelId;
			let model = this.model;
			let promises = Array();

			return Promise.all(promises).then((results) => {
				if (id != '' && id != null && id != undefined) {
					return PostingSupplyForProduction.updateData(this, model, id)
						.catch((error) => {
							return this.getPostingSupplyForProduction(id);
						});
				}
				return false;
			});
		},
		onHidden() {
			this.getPostingSupplyForProductions();
		},
		addRowDataPostingSupplyDetailForProduction(modalEvent, model) {
			if (model != null) {
				model.isScanned = true;
				if (model.id != null && model.id != '') {
					model.postingSupplyForProductionId = this.modelId;
					PostingSupplyDetailForProduction.updateDataDetail(this, model, model.id)
						.then(result => {
							this.AddRowPostingSupplyDetailForProductions(true);
							this.isShowPopupPostingSupplyDetailForProduction = false;
						})
				} else {
					model.postingSupplyForProductionId = this.modelId;
					PostingSupplyDetailForProduction.createDataDetail(this, model)
						.then(result => {
							this.AddRowPostingSupplyDetailForProductions(true);
							this.isShowPopupPostingSupplyDetailForProduction = false;
						})
				}
			}
		},
		async editRowDataPostingSupplyDetailForProduction(id) {
			this.postingSupplyDetailForProductionId = id;
			this.isShowPopupPostingSupplyDetailForProduction = true;
		},
		async deleteRowDataPostingSupplyDetailForProduction(id) {
			PostingSupplyDetailForProduction.deleteData(this, id).then(result => { this.AddRowPostingSupplyDetailForProductions(); });
		},
		async resetDataPostingSupplyDetailForProduction() {
			this.postingSupplyDetailForProductionId = "";
			this.isShowPopupPostingSupplyDetailForProduction = true;
		},
		async addDataPostingSupplyDetailForProduction() {
			PostingSupplyDetailForProduction.createData(this, { postingSupplyForProductionId: this.modelId })
				.then(result => {
					this.AddRowPostingSupplyDetailForProductions(true);
				})
		},
		async addFromClipboardPostingSupplyDetailForProduction() {
			let pickingSupplyForProductionDetails = new Array();
			navigator.clipboard.readText().then(value => {
				if (value.match(/(?:\r\n|\r|\n)/g)) { value = value.replace(/(?:\r\n|\r|\n)/g, ','); }
				let values = value.split(",");
				values.forEach(item => {
					pickingSupplyForProductionDetails.push({ pickingSupplyForProductionDetail: item, postingSupplyForProductionId: this.modelId });
				});
				PostingSupplyDetailForProduction.addFromClipboard(this, pickingSupplyForProductionDetails).then(result => { this.getPostingSupplyDetailForProductions() });
			});
		},
		async replaceFromClipboardPostingSupplyDetailForProduction() {
			let pickingSupplyForProductionDetails = new Array();
			navigator.clipboard.readText().then(value => {
				if (value.match(/(?:\r\n|\r|\n)/g)) { value = value.replace(/(?:\r\n|\r|\n)/g, ','); }
				let values = value.split(",");
				values.forEach(item => {
					pickingSupplyForProductionDetails.push({ pickingSupplyForProductionDetail: item, postingSupplyForProductionId: this.modelId });
				});
				PostingSupplyDetailForProduction.replaceFromClipboard(this, pickingSupplyForProductionDetails).then(result => { this.getPostingSupplyDetailForProductions() });
			});
		},
		showPopupUploadPostingSupplyDetailForProduction() {
			this.isShowPopupUploadPostingSupplyDetailForProduction = true;
		},
		uploadDataPostingSupplyDetailForProduction(modalEvent, newDatas) {
			this.isShowPopupUploadPostingSupplyDetailForProduction = false;
		},
		downloadPostingSupplyDetailForProduction(modalEvent) {
			this.isDownloadPostingSupplyDetailForProduction = true;
			this.filterPostingSupplyDetailForProduction.postingSupplyForProductionId = this.modelId;
			PostingSupplyDetailForProduction.downloadDataDetail(this, this.filterPostingSupplyDetailForProduction).then(result => {
				this.isDownloadPostingSupplyDetailForProduction = false;
			}).catch(error => { this.isDownloadPostingSupplyDetailForProduction = false; })
		},
		saveInputPostingSupplyDetailForProduction(item) {
			if (this.postingSupplyForProductions != null && this.postingSupplyForProductions != undefined && this.postingSupplyForProductions.length > 0) {
				item.postingSupplyForProduction = this.postingSupplyForProductions.find(q => q.id == item.postingSupplyForProductionId);
			}
			if (this.pickingSupplyForProductionDetails != null && this.pickingSupplyForProductionDetails != undefined && this.pickingSupplyForProductionDetails.length > 0) {
				item.pickingSupplyForProductionDetail = this.pickingSupplyForProductionDetails.find(q => q.id == item.pickingSupplyForProductionDetailId);
			}
			if (this.parts != null && this.parts != undefined && this.parts.length > 0) {
				item.part = this.parts.find(q => q.id == item.partId);
			}
			if (this.userInfos != null && this.userInfos != undefined && this.userInfos.length > 0) {
				item.picPicking = this.userInfos.find(q => q.id == item.picPickingUserName);
			}
			if (this.lines != null && this.lines != undefined && this.lines.length > 0) {
				item.line = this.lines.find(q => q.id == item.lineId);
			}
			if (this.areas != null && this.areas != undefined && this.areas.length > 0) {
				item.area = this.areas.find(q => q.id == item.areaId);
			}
			if (this.racks != null && this.racks != undefined && this.racks.length > 0) {
				item.rack = this.racks.find(q => q.id == item.rackId);
			}
			if (this.documentStatuss != null && this.documentStatuss != undefined && this.documentStatuss.length > 0) {
				item.documentStatus = this.documentStatuss.find(q => q.id == item.documentStatusId);
			}

			let id = item.id;
			let promises = Array();

			Promise.all(promises).then((results) => {
				if (id != '' && id != null && id != undefined) {
					PostingSupplyDetailForProduction.updateData(this, item, item.id);
				}
			});
		},
		addRowDataPostingSupplyCase(modalEvent, model) {
			if (model != null) {
				model.isScanned = true;
				if (model.id != null && model.id != '') {
					model.postingSupplyForProductionId = this.modelId;
					PostingSupplyCase.updateDataDetail(this, model, model.id)
						.then(result => {
							this.getPostingSupplyCases(true);
							this.isShowPopupPostingSupplyCase = false;
						})
				} else {
					model.postingSupplyForProductionId = this.modelId;
					PostingSupplyCase.createDataDetail(this, model)
						.then(result => {
							this.getPostingSupplyCases(true);
							this.isShowPopupPostingSupplyCase = false;
						})
				}
			}
		},
		async editRowDataPostingSupplyCase(id) {
			this.postingSupplyCaseId = id;
			this.isShowPopupPostingSupplyCase = true;
		},
		async deleteRowDataPostingSupplyCase(id) {
			PostingSupplyCase.deleteData(this, id).then(result => { this.getPostingSupplyCases(); });
		},
		async resetDataPostingSupplyCase() {
			this.postingSupplyCaseId = "";
			this.isShowPopupPostingSupplyCase = true;
		},
		async addDataPostingSupplyCase() {
			PostingSupplyCase.createData(this, { postingSupplyForProductionId: this.modelId })
				.then(result => {
					this.getPostingSupplyCases(true);
				})
		},
		async addFromClipboardPostingSupplyCase() {
			let postingSupplyDetailForProductions = new Array();
			navigator.clipboard.readText().then(value => {
				if (value.match(/(?:\r\n|\r|\n)/g)) { value = value.replace(/(?:\r\n|\r|\n)/g, ','); }
				let values = value.split(",");
				values.forEach(item => {
					postingSupplyDetailForProductions.push({ postingSupplyDetailForProduction: item, postingSupplyForProductionId: this.modelId });
				});
				PostingSupplyCase.addFromClipboard(this, postingSupplyDetailForProductions).then(result => { this.getPostingSupplyCases() });
			});
		},
		async replaceFromClipboardPostingSupplyCase() {
			let postingSupplyDetailForProductions = new Array();
			navigator.clipboard.readText().then(value => {
				if (value.match(/(?:\r\n|\r|\n)/g)) { value = value.replace(/(?:\r\n|\r|\n)/g, ','); }
				let values = value.split(",");
				values.forEach(item => {
					postingSupplyDetailForProductions.push({ postingSupplyDetailForProduction: item, postingSupplyForProductionId: this.modelId });
				});
				PostingSupplyCase.replaceFromClipboard(this, postingSupplyDetailForProductions).then(result => { this.getPostingSupplyCases() });
			});
		},
		showPopupUploadPostingSupplyCase() {
			this.isShowPopupUploadPostingSupplyCase = true;
		},
		uploadDataPostingSupplyCase(modalEvent, newDatas) {
			this.isShowPopupUploadPostingSupplyCase = false;
		},
		downloadPostingSupplyCase(modalEvent) {
			this.isDownloadPostingSupplyCase = true;
			this.filterPostingSupplyCase.postingSupplyForProductionId = this.modelId;
			PostingSupplyCase.downloadDataDetail(this, this.filterPostingSupplyCase).then(result => {
				this.isDownloadPostingSupplyCase = false;
			}).catch(error => { this.isDownloadPostingSupplyCase = false; })
		},
		saveInputPostingSupplyCase(item) {
			if (this.postingSupplyDetailForProductions != null && this.postingSupplyDetailForProductions != undefined && this.postingSupplyDetailForProductions.length > 0) {
				item.postingSupplyDetailForProduction = this.postingSupplyDetailForProductions.find(q => q.id == item.postingSupplyDetailForProductionId);
			}
			if (this.controlCards != null && this.controlCards != undefined && this.controlCards.length > 0) {
				item.controlCard = this.controlCards.find(q => q.id == item.controlCardId);
			}

			let id = item.id;
			let promises = Array();

			Promise.all(promises).then((results) => {
				if (id != '' && id != null && id != undefined) {
					PostingSupplyCase.updateData(this, item, item.id);
				}
			});
		},
		resetModal(modalType) {
			this.isShowPopupUploadPostingSupplyDetailForProduction = false;
			this.isShowPopupPostingSupplyDetailForProduction = false;
			if (modalType == 'PostingSupplyDetailForProduction') {
				this.getPostingSupplyDetailForProductions();
			}
			this.isShowPopupUploadPostingSupplyCase = false;
			this.isShowPopupPostingSupplyCase = false;
			if (modalType == 'PostingSupplyCase') {
				this.getPostingSupplyCases();
			}
			this.showPopupCopyData = false;
			this.isShowPopupConfirmation = false;
		},
		displayFilter() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 768) {
			}
		},
		async goToNext(page, item) {
			if (page == 1) {
				this.rackQrCode = "";
				this.getPostingSupplyDetailForProductions(null);
				this.scanPageIndex = page;
				return;
			}
			if (page == 2) {
				this.postingDetail = item;
				this.scanPageIndex = page;
				this.parentLabelInfo = this.postingDetail.materialPart != null ? this.postingDetail.materialPart.partNumber : '';
				this.getPostingSupplyCases();
				return;
			}

			if (page == 3) {
				this.scanPageIndex = page;
				return;
			}

			if (page == 4) {
				let errMessage = "";
				if (this.picPickingQrCode == "" || this.picPickingQrCode == undefined) {
					errMessage += "Pic Picking Material Issue tidak boleh kosong.";
				}
				if (this.picPenerimaQrCode == "" || this.picPenerimaQrCode == undefined) {
					if (errMessage != "") {
						errMessage += " ";
					}
					errMessage += "Pic penerima tidak boleh kosong.";
				}

				if (errMessage != "") {
					this.toast({ message: errMessage, title: 'Error', variant: 'danger' });
					return;
				}
				let scan = await this.scanPic();

				if (scan == true) {
					this.picPenerimaQrCode = "";
					this.picPickingQrCode = "";
					this.scanPageIndex = page;
				}
				return;
			}
		},
	},
	beforeMount() {
		this.filterPostingSupplyForProduction = new PostingSupplyForProductionFilter();
		this.filterPostingSupplyDetailForProduction = new PostingSupplyDetailForProductionFilter();
		this.filterPostingSupplyCase = new PostingSupplyCaseFilter();
		//this.getPostingSupplyForProductions();
		//this.getPickingSupplyForProductionDetails();
		//this.getParts();
		//this.getUserInfos();
		//this.getLines();
		//this.getAreas();
		//this.getRacks();
		//this.getDocumentStatuss();
		//this.getPostingSupplyDetailForProductions();
		//this.getControlCards();
		//this.getPickingSupplyForProductions();
		//this.getWorkOrderSupplys();
		//this.getWorkOrderProcesss();
	},
	async mounted() {
		let id = this.$route.params.id;
		if (id != '' && id != null && id != undefined) {
			this.modelId = id;
			this.getPostingSupplyForProduction(id);
			this.getPostingSupplyDetailForProductions(null);
		}
		this.$nextTick(() => {

			window.addEventListener('resize', this.displayFilter);
			this.displayFilter();
		});
	},
	computed: {
	},
	watch: {
		filterMaterial(value) {
			this.getPostingSupplyDetailForProductions(value);
		},
		scanPageIndex() {
			this.hideToast();
		}
	},
}
</script>
